$(document).ready(function(){
    $('.custom-application-slider-for').each(function(key, item) {

        var sliderIdName = 'slider' + key;
        var sliderNavIdName = 'sliderNav' + key;

        this.id = sliderIdName;
        $('.custom-application-slider-nav')[key].id = sliderNavIdName;

        var sliderId = '#' + sliderIdName;
        var sliderNavId = '#' + sliderNavIdName;

        $(sliderId).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: sliderNavId,
          	dots: true,
            adaptiveHeight: true,
            responsive: [
            {
            breakpoint: 600,
            settings: {
                dots: true,
                arrows: false,
                centerMode: true,
                fade: false,
            }
            }
        ]
        });
        $(sliderNavId).slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            asNavFor: sliderId,
            dots: true,
            adaptiveHeight: true,
            centerMode: true,
            focusOnSelect: true,
            arrows: false
        });
    })
});
